import React from 'react';
import { GMBox } from '../../Box';
import { GoMotoComponent } from '../../../API/GoMoto.types';
import { GMInfoGridProps } from './GMInfoGrid.types';

export const GMInfoGrid: GoMotoComponent<GMInfoGridProps> = React.memo((props) => (
    <div>
        <GMBox color={'primary'}>{props.children}</GMBox>
    </div>
));
